
import { Routes} from '@angular/router';
import { AuthenticationComponent } from './authentication.component';
import { ErrorComponent } from './error/error.component';
import { ForgotComponent } from './forgot/forgot.component';
import { LockscreenComponent } from './lockscreen/lockscreen.component';
import { RegisterComponent } from './register/register.component';
export const AuthenticationRoutes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'login',
        component: AuthenticationComponent
      },
      {
        path: '404',
        component: ErrorComponent
      },
      {
        path: 'esqueci-senha',
        component: ForgotComponent
      },
      {
        path: 'lockscreen',
        component: LockscreenComponent
      },
      {
        path: 'register',
        component: RegisterComponent
      }
    ],
  },
];


